import Vue from 'vue'
import VueI18n from 'vue-i18n'
import pl from './pl'
import en from './en'

Vue.use(VueI18n)

export default new VueI18n({
   locale: (window.navigator.userLanguage || window.navigator.language || 'en').split('-')[0],
   fallbackLocale: 'en',
   messages: {
      pl,
      en
   }
})


// WEBPACK FOOTER //
// ./src/i18n/index.js